import { nexusHeaders, requestJson } from './http';

function queryString(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      if (value.length) search.set(key, value.join(','));
    } else if (value !== undefined && value !== null && value !== '') {
      search.set(key, value);
    }
  });
  return search.toString();
}

export function getReservationReport(type, params = {}) {
  const query = queryString(params);
  return requestJson(`/api/reports/${encodeURIComponent(type)}${query ? `?${query}` : ''}`);
}

export function reservationReportExportUrl(type, params = {}) {
  const query = queryString(params);
  return `/api/reports/${encodeURIComponent(type)}/export${query ? `?${query}` : ''}`;
}

export async function downloadReservationReport(type, params = {}, format = 'csv') {
  const response = await fetch(reservationReportExportUrl(type, { ...params, format }), { headers: nexusHeaders() });
  if (!response.ok) throw new Error(`Report export failed (${response.status})`);
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${type}-report.${format}`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
